import { Component, OnInit, Inject } from '@angular/core';
import { Transition } from '@uirouter/angular';

@Component({
    selector: 'app-ms',
    template: '',
    styles: []
})
export class MsComponent implements OnInit {
    constructor(@Inject('apiService') public apiService, public transition: Transition) {}

    ngOnInit() {
        if (
            window.location.hostname === '127.0.0.1' ||
            window.location.hostname === 'localhost' ||
            window.location.hostname === 'dev-calendarhero.com'
        ) {
            if (document.location.href.indexOf(document.location.host + '/ms/') > -1) {
                window.location.href = document.location.href.replace(
                    document.location.host + '/ms/',
                    'dev-calendarhero.com:8000/register/'
                );
                return;
            }
        }
    }
}
